import React from 'react';

import type { PostWithLoadingState } from 'src/blog-item/types';
import { Markdown } from 'src/misc/markdown';

import './blog-post.css';

type BlogPostProps = {
  post: PostWithLoadingState;
};

export const BlogPost = ({ post }: BlogPostProps) => (
  <div className="blog-item-post">
    {post.category && (
      <p className="blog-item-post__category">{post.category.title}</p>
    )}
    <h1>{post.title}</h1>
    {post.formattedPublishedAt && (
      <p className="blog-item-post__date">{post.formattedPublishedAt}</p>
    )}
    <img
      src={`${post.coverImage.url}?w=600`}
      alt={post.coverImage.title}
      className="blog-item-post__cover-image"
    />

    <div className="blog-item-post__content">
      <Markdown withRemark>{post.post}</Markdown>
    </div>
  </div>
);
